import { useSearchParams } from 'react-router-dom'
import { useRealtimeParticipants } from '../../hooks/useRealtime'
import { StandingsOverlay } from '../../components/overlay/StandingsOverlay'

export function StandingsPage() {
  const [searchParams] = useSearchParams()
  const raceId = searchParams.get('race') || ''

  const { participants } = useRealtimeParticipants(raceId)

  return (
    <div className="w-full h-screen bg-transparent">
      <StandingsOverlay participants={participants} compact={true} />
    </div>
  )
}
